import React, { useEffect, useState } from "react";
// import {
//   ResponsiveContainer,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Line,
//   ComposedChart,
//   LabelList,
// } from "recharts";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import { Bar } from "react-chartjs-2";
import RelevantReports from "./RelevantReports";
import ResponsiveTable from "./Statisitcs";
// import GlobalDataSummary from "./GlobalReport";
// import MarketScope from "./MarketScope";
import MarketOutlook from "./MarketOutlook";
import StackedBarChart from "./StackedBarChart";
import HorizontalBarChart from "./TopCountries";
import BubbleChart from "./BubbleChart";
import PieChartSection from "./PieChart";
import MarketCards from "../listing/marketCard";
import { useLocation, useSearchParams } from "react-router";
import MarketScope from "../listing/marketScope";
import GlobalDataSummary from "../listing/globalDataSummary";
import axiosClient from "../../axios-client";
const data = [
  { year: 2018, value: 55.3, percent: 45.3 },
  { year: 2019, value: 58.8, percent: 33.0 },
  { year: 2020, value: 67.5, percent: 33.0 },
  { year: 2021, value: 49.5, percent: 30.0 },
  { year: 2022, value: 45.7, percent: 29.0 },
  { year: 2023, value: 55.9, percent: 29.0 },
  { year: 2024, value: 62.4, percent: 29.0 },
  { year: 2025, value: 79.5, percent: 29.0 },
  { year: 2026, value: 84.3, percent: 29.0 },
];

function MarketOverview() {
  const location = useLocation();
  const report = location.state; // Access the passed report data
  const [searchParams] = useSearchParams();
  const region = searchParams.get("region"); // Gets the 'region' from URL
  const country = searchParams.get("country_name");
  const title = country ? country : region;
  const [activeTab, setActiveTab] = useState("overview");
  const [uniqueNamesArray, setUniqueNamesArray] = useState([]);
  const [SegmentsWithSubSegments, setSegmentsWithSubSegments] = useState([]);
  const [firstYear, setfirstYear] = useState("");
  const [segments, setSegments] = useState([]);
  const [lastYear, setlastYear] = useState("");
  const [chartData, setChartData] = useState(null);
  const [countryYearsData, setCountryYearsData] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const handleDownloads = () => {
    const fileUrl = "/path-to-your-file/report.pdf";
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "comprehensive_report.pdf");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleDownload = () => {
    const content =
      "This is the downloaded content for the market overview report.";

    const blob = new Blob([content], { type: "text/plain" });

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "market_overview_report.txt";

    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  useEffect(() => {
    if (country) {
      const filterData = report?.regions?.filter(
        (item) => item.country === country
      );
      const segments = report?.segments?.filter(
        (item) => item.country === country
      );
      setSegments(segments);
      setCountryYearsData(filterData);
    }
    if (region) {
      const filterData = report?.regions?.filter(
        (item) => item.region === region
      );
      setCountryYearsData(filterData);
    }
  }, [country, region]);
  useEffect(() => {
    if (report?.regions) {
      const countriesList = report.regions.map((region) => region.country);

      const regionsList = [
        ...new Set(report.regions.map((region) => region.region)),
      ];

      // Object to group sub-segments by their parent segment
      const segmentsWithSubSegments = {};

      // Convert Sets to arrays for rendering
      const segmentsWithSubSegmentsArray = {};
      for (const [key, value] of Object.entries(segmentsWithSubSegments)) {
        segmentsWithSubSegmentsArray[key] = Array.from(value);
      }

      // Set the cleaned object in state
      setSegmentsWithSubSegments(segmentsWithSubSegmentsArray);

      // Create a unique names array
      const uniqueNamesArray = Object.keys(segmentsWithSubSegmentsArray);
      setUniqueNamesArray(uniqueNamesArray);
      // console.log("dgd", uniqueNamesArray, SegmentsWithSubSegments);
    }
  }, [report]);

  useEffect(() => {
    if (countryYearsData?.length > 0) {
      let years = [];
      let values = [];

      if (country) {
        // Get data from the first index for the selected country
        years = countryYearsData[0]?.years?.map((item) => item.year) || [];
        values = countryYearsData[0]?.years?.map((item) => item.value) || [];
      } else if (region) {
        // Collect all years and sum values across countries in the selected region
        const allYears = countryYearsData.flatMap((item) => item.years || []);

        years = [...new Set(allYears.map((item) => item.year))].sort(
          (a, b) => a - b
        );
        values = years.map(
          (year) =>
            allYears
              .filter((item) => item.year === year)
              .reduce((sum, curr) => sum + curr.value, 0) // Summing values for each year
        );
      }

      setfirstYear(years[0] || 0);
      setlastYear(years.at(-1) || 0);

      setChartData({
        labels: years,
        datasets: [
          {
            label: "Value",
            data: values,
            backgroundColor: "rgba(146, 51, 81, 1)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
            borderRadius: 5,
            datalabels: {
              display: true,
              align: "end",
              anchor: "end",
              formatter: (value) => `$${value.toFixed(2)}`,
            },
          },
        ],
      });
    }
  }, [countryYearsData]);

  const yearsMap = new Map();

  // If a country is selected, take the first country's data
  if (country && countryYearsData.length > 0) {
    countryYearsData[0]?.years?.forEach(({ year, value }) => {
      yearsMap.set(year, value);
    });
  }
  // If a region is selected, sum up values of all countries in that region
  else if (region && countryYearsData.length > 0) {
    countryYearsData.forEach(({ years }) => {
      years.forEach(({ year, value }) => {
        yearsMap.set(year, (yearsMap.get(year) || 0) + value);
      });
    });
  }
  // Extract sorted years and values
  const sortedYears = Array.from(yearsMap.keys()).sort((a, b) => a - b);
  const firstYea = sortedYears[0] || "N/A";
  const lastYea = sortedYears.at(-1) || "N/A";
  const firstValue = yearsMap.get(firstYea) || 0;
  const lastValue = yearsMap.get(lastYea) || 0;

  // Get CAGR (assuming first entry in countryYearsData has it)
  const cagr = Number(countryYearsData?.[0]?.cagr || 0)?.toFixed(2);
  const newPropsData = {
    firstYear: firstYea,
    lastYear: lastYea,
    firstValue: firstValue.toFixed(2),
    lastValue: lastValue.toFixed(2),
    cagr_last: cagr,
  };
  const cardData = [
    {
      title: "Revenue",
      year: firstYea,
      value: firstValue ? `$${firstValue.toFixed(2)}` : "N/A",
      icon: "images/bag.png",
    },
    {
      title: "Forecast",
      year: lastYear,
      value: lastValue ? `$${lastValue.toFixed(2)}` : "N/A",
      icon: "images/forecast.png",
    },
    {
      title: "CAGR",
      year: `${firstYea} - ${lastYea}`,
      value: cagr ? `${cagr}%` : "N/A",
      icon: "images/grow.png",
    },
    {
      title: title,
      year: "",
      value: "Report",
      icon: "images/send.png",
    },
  ];
  const downloadChartAsPNG = () => {
    const canvas = document.getElementById("chartCanvas");
    addDownloads();
    html2canvas(canvas).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = imgData;
      link.download = `${report?.reportTitle}}_chart.png`;
      link.click();
    });
  };
  const graphData = report?.Title_year;
  // Download data as Excel
  const downloadDataAsExcel = () => {
    const data = [
      ["Year", "Revenue"], // Header row
      ...graphData.map((item) => [item.year, item.value]), // Data rows
    ];
    addDownloads();
    const ws = XLSX.utils.aoa_to_sheet(data); // Create a worksheet
    const wb = XLSX.utils.book_new(); // Create a workbook
    XLSX.utils.book_append_sheet(wb, ws, "Revenue Data"); // Append sheet to workbook

    XLSX.writeFile(wb, `${report?.reportTitle}_data.xlsx`); // Export to Excel file
  };
  const [subscriptions, setSubscriptions] = useState([]);
  const [userData, setUserData] = useState();
  const userID = localStorage.getItem("userID");
  const fetchSubscriptions = async () => {
    try {
      const response = await axiosClient.get(
        `/subscriptions/getSubscriptionsByUser/${userID}`
      );
      setSubscriptions(response.data);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    }
  };
  const addDownloads = async () => {
    const subscriptionId = subscriptions[0]?._id;
    try {
      const response = await axiosClient.patch(
        `/subscriptions/update-plan/${subscriptionId}`
      );
      fetchSubscriptions();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const plansData = sessionStorage.getItem("plans");
    if (plansData) {
      const parsedData = JSON.parse(plansData);
      setUserData(parsedData);
    }
    fetchSubscriptions();
  }, []);
  return (
    <div className="">
      <div className="mb-8 font-inter">
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold font4">
          {country ? country : region}{" "}
          {report?.reportTitle?.replace(/Global\s+|\s+Size Study/g, "")} &
          Forecast Outlook
        </h1>
      </div>
      {activeTab === "overview" ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 md:gap-7 gap-4 font-inter">
          {cardData.map((card, index) => (
            <div
              key={index}
              className="bg-white border1 p-4 sm:p-6 md:p-7 rounded-xl shadow flex items-center justify-between transition-all duration-300 ease-in-out hover:shadow-lg hover:scale-105 w-full"
            >
              <div className="flex flex-col">
                <p className="font-medium text-xs sm:text-sm font14">
                  {card.title}
                  {card.year && (
                    <span className="font15 ml-1">{card.year}</span>
                  )}
                </p>
                <h3 className="text-lg sm:text-xl lg:text-2xl font-bold mt-1 font16">
                  {card.value}
                </h3>
              </div>
              <img
                src={card.icon}
                alt={card.title}
                className="w-6 h-5 sm:w-8 sm:h-7 object-contain"
              />
            </div>
          ))}
        </div>
      ) : (
        <div></div>
      )}

      {/* Tabs */}
      <div className="flex space-x-4 border3 mt-4 mb-4">
        <button
          className={`py-2 px-4  font-inter ${
            activeTab === "overview"
              ? "border2 font2 font-semibold"
              : "text-black"
          }`}
          onClick={() => setActiveTab("overview")}
        >
          Overview
        </button>
        <button
          className={`py-2 px-4  font-inter ${
            activeTab === "statistics"
              ? "border2 font2  font-semibold"
              : "text-black"
          }`}
          onClick={() => setActiveTab("statistics")}
        >
          Statistics
        </button>
      </div>

      {activeTab === "overview" ? (
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-5 mt-8">
            <div className="lg:col-span-3 bg-white p-6 rounded-xl shadow border1 h-fit">
              <div className=" mb-4 flex flex-col lg:flex-row items-center justify-between font-inter"></div>
              <div className="overflow-x-auto">
                <div
                  style={{ width: `${data.length * 62}px`, minWidth: "100%" }}
                >
                  {/* <div className="bg-white rounded shadow p-6 mb-6 w-3/4"> */}

                  <div
                    className="relative  text-left"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <h2 className="text-xl font-bold max-w-lg font4">
                      {country ? country : region}{" "}
                      {report?.reportTitle?.replace(
                        /Global\s+|\s+Size Study/g,
                        ""
                      )}{" "}
                      {countryYearsData[0]?.years[0]?.year}-
                      {countryYearsData[0]?.years.at(-1)?.year}
                      (US$M)
                    </h2>
                    {userData?.features?.graphDownloadLimit >
                      subscriptions[0]?.downloads?.downloadGraphs && (
                      <button
                        className="  bg-black text-white px-4 py-2 rounded inline-flex items-center"
                        style={{ fontSize: "12px" }}
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                      >
                        Download Options
                        <svg
                          className="ml-2 w-4 h-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.23 7.21a.75.75 0 011.06.02L10 11.293l3.71-4.063a.75.75 0 111.08 1.04l-4.5 4.916a.75.75 0 01-1.08 0l-4.5-4.916a.75.75 0 01.02-1.06z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    )}
                    {dropdownOpen && (
                      <div
                        className="absolute  mt-2 w-48 bg-white rounded-md shadow-lg z-10"
                        onMouseLeave={() => setDropdownOpen(false)}
                        style={{ top: 30, right: 0 }}
                      >
                        <div className="py-1">
                          <button
                            onClick={downloadChartAsPNG}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                          >
                            Download PNG
                          </button>
                          <button
                            onClick={downloadDataAsExcel}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                          >
                            Download Excel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="w- h-70  rounded flex items-center ">
                    {chartData ? (
                      <>
                        <Bar
                          id="chartCanvas"
                          data={chartData}
                          options={{
                            responsive: true,
                            plugins: {
                              legend: {
                                position: "top",
                              },
                              title: {
                                display: true,
                                // text: "Yearly Values with CAGR",
                              },
                            },
                          }}
                        />
                      </>
                    ) : (
                      <p className="text-gray-500">No data available</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className=" lg:col-span-1 ">
              {/* <RelevantReports /> */}
              <MarketCards report={report} />
            </div>
            {/* <div className="bg-white lg:col-span-3 p-6 rounded-xl shadow border1 -mt-24 font-inter h-fit">
              <h3 className="text-xl font-bold mb-4 font4">
                Global XYZ market Insights
              </h3>
              <p className="font14 mb-6">
                The spatial genomics & transcriptomics industry worldwide is
                expected to reach a projected revenue of US$ 631.7 million by
                2030. A compound annual growth rate of 10.7% is expected of the
                worldwide spatial genomics & transcriptomics industry from 2024
                to 2030.
              </p>
              <ul className="list-disc pl-6 font14 space-y-3">
                <li>
                  The global spatial genomics & transcriptomics market generated
                  a revenue of USD 310.0 million in 2023 and is expected to
                  reach USD 631.7 million by 2030.
                </li>
                <li>
                  The market is expected to grow at a CAGR (2024 - 2030) of
                  10.7% by 2030.
                </li>
                <li>
                  In terms of segment, consumables accounted for a revenue of
                  USD 163.5 million in 2023.
                </li>
                <li>
                  PVDF is the most lucrative product segment registering the
                  fastest growth during the forecast period.
                </li>
                <li>
                  In terms of region, North America was the largest revenue
                  generating market in 2023.
                </li>
                <li>
                  Country-wise, Kuwait is expected to register the highest CAGR
                  from 2024 to 2030.
                </li>
              </ul>
            </div> */}

            {/* <div className="bg-white p-6 rounded-xl shadow border1 font-inter h-fit">
              <h3 className="text-lg font-bold mb-4 font4">
                Bizwit at a Glance
              </h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center gap-2 ">
                  <img
                    src="images/check_circle.png"
                    alt="ff"
                    className="w-5 h-5"
                  />
                  40K+ Comprehensive Market Reports
                </li>
                <li className="flex items-center gap-2">
                  <img
                    src="images/check_circle.png"
                    alt="ff"
                    className="w-5 h-5"
                  />
                  150K+ Country-Specific Reports
                </li>
                <li className="flex items-center gap-2 ">
                  <img
                    src="images/check_circle.png"
                    alt="ff"
                    className="w-5 h-5"
                  />
                  1.5M+ Market Data Points
                </li>
                <li className="flex items-center gap-2 ">
                  <img
                    src="images/check_circle.png"
                    alt="ff"
                    className="w-5 h-5"
                  />
                  250K+ Company Analyses
                </li>
              </ul>
              <button className="mt-6 bg-[#15171a] text-white py-3 px-4 rounded-lg w-full font-dmSans text-base font-semibold hover:bg-[#21242a]">
                Ask a question
              </button>
            </div> */}
          </div>
          {/* <GlobalDataSummary /> */}
          <div style={{ margin: "15px 0px" }}>
            <GlobalDataSummary
              reportTitle={`${title} Market Report`}
              report={report}
              data={newPropsData}
              uniqueNamesArray={uniqueNamesArray}
              firstYear={firstYea}
              lastYear={lastYea}
            />
          </div>
          {/* <MarketScope /> */}
          {/* <MarketOutlook /> */}
          <MarketScope report={report} />
          {/* <StackedBarChart /> */}
          {/*<HorizontalBarChart />*/}
          {/* <BubbleChart /> */}
          <PieChartSection segments={report} />
        </div>
      ) : (
        <div>
          <ResponsiveTable segments={report} />
        </div>
      )}
    </div>
  );
}

export default MarketOverview;
